import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import userReducer from './slices/userSlice';
import settingsReducer from './slices/settingsSlice';
import sessionsReducer from './slices/sessionsSlice';
import portfolioReducer from './slices/portfolioSlice';

function appSettingsReducer(state, action) {
  const settings = settingsReducer(state?.settings, action);
  return { settings };
}

function userDetailsReducer(state = { user: null }, action) {
  const nextUserState = userReducer(
    state.user != null ? { message: 'success', user: state.user } : undefined,
    action
  );
  return { user: nextUserState?.user ?? null };
}

const rootReducer = combineReducers({
  appSettings: appSettingsReducer,
  userDetails: userDetailsReducer,
  sessions: sessionsReducer,
  portfolio: portfolioReducer,
});

const thunkMiddleware = ({ dispatch, getState }) => (next) => (action) => {
  if (typeof action === 'function') {
    return action(dispatch, getState);
  }
  return next(action);
};

export function makeStore(preloadedState) {
  const middlewareEnhancer = applyMiddleware(thunkMiddleware);

  const composeEnhancers =
    process.env.NODE_ENV !== 'production' ? composeWithDevTools : (f) => f;

  return createStore(rootReducer, preloadedState, composeEnhancers(middlewareEnhancer));
}

export const store = makeStore();
